<template>
  <div class="row">
    <div class="col-12">
      <h4>Tasks</h4>
      <div v-if="isLoading" class="text-center text-muted">
        <div class="spinner-border large-spinner" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-if="tasks && tasks.length > 0" class="list-group">
        <div v-for="(item, index) in tasks" :key="item.id" class="list-group-item">
          <div class="d-flex justify-content-between">
            <div>{{ item.type | capitalize }} {{ item.request && item.request.resource_type ? item.request.resource_type : "" }}</div>
            <div>{{ item.created_at | shortPrettyDateTime }}</div>
          </div>
          <div class="d-flex justify-content-between mt-2">
            <div>
              <span
                class="badge"
                :class="{
                  'badge-info': item.status == 'new',
                  'badge-warning': item.status == 'progress',
                  'badge-success': item.status == 'completed',
                  'badge-danger': item.status == 'error'
                }">
                {{ item.status }}
              </span>
            </div>
            <div>
              <a
                v-if="item.url && item.type == 'export'"
                :href="item.url"
                download
                class="text-decoration-none"
              >
                Download Export <font-awesome-icon icon="download" />
              </a>
              <delete-task-button v-if="item.status == 'completed' || item.status == 'error'" :taskId="item.id" class="ml-2" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">
        No tasks running at this time.
      </div>
    </div>
  </div>
</template>

<script>
import LoadingCard from "../Cards/LoadingCard.vue";
import { mapGetters } from "vuex";
import ActivationToggle from "../Inputs/ActivationToggle.vue";
import DeleteTaskButton from "../Buttons/DeleteTaskButton.vue";

export default {
  name: "TasksTable",
  components: {
    LoadingCard,
    ActivationToggle,
    DeleteTaskButton
  },
  props: {
    isActive: Boolean,
  },
  async created() {
    this.$store.commit('task/setTasksHaveUpdates', false);
    await this.$store.dispatch('task/fetchTasks');
    this.$store.dispatch('task/startPolling');
  },
  beforeDestroy() {
    this.$store.dispatch('task/stopPolling');
  },
  computed: {
    ...mapGetters("task", ["tasks", "isLoading"])
  },
};
</script>
